<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" class="count-result" :close-on-click-modal="false" append-to-body width="650px">
    <div slot="title" class="title">
      <div class="title-name">提示<span class="title-btn">以下话术可以直接复制，配合报告一起发送给客户，效果会更好哦~</span></div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div class="count-result-box">
      <pre>{{ text }}</pre>
    </div>
    <div class="count-result-footer">
      <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="copy">一键复制</el-button>
      <el-button style="flex: none" size="mini" @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import copyToClipboard from 'copy-to-clipboard'

const dateFormat = require('dateformat')

export default {
  data() {
    return {
      dialogVisible: false,
      countResult:{},
      index:0,
    }
  },
  computed:{
    dateformat(){
      return dateFormat
    },
    text(){
      const { countResult } = this
      return `Dear：
       您好！年底我们整理了过往合作的数据供您和贵司参考。
       自${countResult.年份}年起，我们合作了超过${countResult.开放职位}个职位，累计推荐了${countResult.推荐}位候选人，其中面试达到${countResult.面试}人次，推荐到面试的转化率大于${countResult.推荐转换为面试率}，目前为止，终面人数为${countResult.终面}，offer人数为${countResult.offer}。具体数据详见附件。其中零职位没有反馈，且反馈速度和面试效率均高于市场平均水平，被评为顾问最愿意服务的战略合作伙伴。

       感恩您一路以来的支持和信任！未来阿尔法会与您一路同行，持续给予最优质的推荐和服务，为贵司提供人力资本超额收益！

                                      阿尔法咨询`
    },
  },
  methods: {
    open(countResult) {
      this.countResult = countResult || {
        年份: new Date().getFullYear(),
        开放职位: 11,
        推荐: 11,
        面试: 11,
        推荐转换为面试率: '20%',
        终面: 11,
        offer: 11,
      }
      this.dialogVisible = true
    },
    copy(){
      try {
        copyToClipboard(this.text)
        this.$message.success('复制成功')
        this.dialogVisible = false
      } catch (e) {
        console.log(e.message);
      }
    },
  },
}
</script>
<style>
.custom-dialog .el-dialog__body {
  padding-top: 0px;
}
.count-result-footer .el-button--primary  {
  background-color: #4394b9;
  border-color: #4394b9;
}
</style>
<style scoped src="../../../company/statistics/css/commonCompany.css"></style>
<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height:1.5;
  margin: 0;
  padding:15px
}
.title-btn {
  margin-left: 30px;
  color: #cbcbcb;
  font-size: 14px;
  cursor: pointer;
}
.count-result-footer{
  display: flex;
  justify-content: center;
}
</style>
